var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUbuntu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_147852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 18.1C14.4734 18.1 18.0999 14.4735 18.0999 9.99999C18.0999 5.52649 14.4734 1.89999 9.9999 1.89999C5.5264 1.89999 1.8999 5.52649 1.8999 9.99999C1.8999 14.4735 5.5264 18.1 9.9999 18.1Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99979 13.9285C12.1694 13.9285 13.9283 12.1697 13.9283 10C13.9283 7.83035 12.1694 6.0715 9.99979 6.0715C7.83014 6.0715 6.07129 7.83035 6.07129 10C6.07129 12.1697 7.83014 13.9285 9.99979 13.9285Z",
    stroke: "white",
    strokeWidth: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49191 11.5188C5.3307 11.5188 6.01068 10.8388 6.01068 10C6.01068 9.16121 5.3307 8.48123 4.49191 8.48123C3.65312 8.48123 2.97314 9.16121 2.97314 10C2.97314 10.8388 3.65312 11.5188 4.49191 11.5188Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10L16 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10L16 10",
    stroke: "#F47421",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49199 11.0814C5.08919 11.0814 5.57333 10.5972 5.57333 10C5.57333 9.4028 5.08919 8.91867 4.49199 8.91867C3.89478 8.91867 3.41064 9.4028 3.41064 10C3.41064 10.5972 3.89478 11.0814 4.49199 11.0814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4386 4.47054C11.0193 5.19695 11.2681 6.12581 11.9946 6.54521C12.721 6.96461 13.6498 6.71572 14.0692 5.9893C14.4886 5.26289 14.2397 4.33402 13.5133 3.91463C12.7869 3.49523 11.858 3.74412 11.4386 4.47054Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12L7 15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12L7 15",
    stroke: "#F47421",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8173 4.68923C11.5187 5.20643 11.6959 5.86777 12.2131 6.16637C12.7303 6.46498 13.3917 6.28777 13.6903 5.77058C13.9889 5.25338 13.8117 4.59204 13.2945 4.29344C12.7773 3.99483 12.116 4.17204 11.8173 4.68923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0694 14.0107C13.65 13.2843 12.7212 13.0354 11.9948 13.4548C11.2684 13.8742 11.0195 14.803 11.4389 15.5295C11.8583 16.2559 12.7871 16.5048 13.5135 16.0854C14.2399 15.666 14.4888 14.7371 14.0694 14.0107Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8L7 5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8L7 5",
    stroke: "#F47421",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6907 14.2294C13.3921 13.7122 12.7307 13.535 12.2135 13.8336C11.6963 14.1322 11.5191 14.7936 11.8177 15.3108C12.1163 15.828 12.7777 16.0052 13.2949 15.7066C13.8121 15.4079 13.9893 14.7466 13.6907 14.2294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_147852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUbuntu);
export default __webpack_public_path__ + "static/media/ic-ubuntu.7cd7cc1a854a0046f74abc4fb99ecb27.svg";
export { ForwardRef as ReactComponent };